export default __webpack_public_path__ + "2c34c138cf23da44477b735b86838462.svg";